module.exports = {
  BASE_URI: '/api'
}
